import { render, staticRenderFns } from "./pageDesc.vue?vue&type=template&id=234665e9"
import script from "./pageDesc.vue?vue&type=script&lang=js"
export * from "./pageDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports